import {
  addDays,
  compareAsc,
  compareDesc,
  differenceInDays,
  isAfter,
  isBefore,
  isEqual,
  isSameDay,
  max,
  min,
  startOfDay,
} from "date-fns";
import { MonthEvent } from "./MonthView";

export class EventEditor {
  public startDateTime: Date;
  public endDateTime: Date;
  public startDate: Date;
  public endDate: Date;
  constructor(private m: MonthEvent) {
    this.startDateTime = new Date(m.startDateTime);
    this.endDateTime = new Date(m.endDateTime);

    // Handle case where all day events are saved with the same start/end date (end date should always be beginning of next day)
    if (this.allDay && isEqual(this.startDateTime, this.endDateTime)) this.endDateTime = addDays(this.endDateTime, 1);

    this.startDate = startOfDay(this.startDateTime);
    this.endDate = startOfDay(this.endDateTime);
    // Adjust non all day multi day events.
    if (!isEqual(this.endDateTime, this.endDate)) this.endDate = addDays(this.endDate, 1);
  }

  get allDay(): boolean {
    return this.m.allDay;
  }

  get calendarClass(): string {
    return this.m.calendarClass;
  }

  get eventActionsHTML(): string {
    return this.m.eventActionsHTML;
  }

  get updateIconsHTML(): string {
    return this.m.updateIconsHTML;
  }

  get timeHTML(): string {
    return this.m.timeHTML;
  }

  get assetIconsHTML(): string {
    return this.m.assetIconsHTML;
  }

  get titleHTML(): string {
    return this.m.titleHTML;
  }

  get title(): string {
    return this.m.title;
  }

  get extraFieldHTML(): string {
    return this.m.extraFieldHTML;
  }

  get popupAttributes(): object {
    return this.m.popupAttributes || {};
  }

  public static eventComparer(a: EventEditor, b: EventEditor): number {
    const startDateCompare = compareAsc(a.startDateTime, b.startDateTime);
    if (startDateCompare == 0) return compareDesc(a.endDateTime, b.endDateTime);
    return startDateCompare;
  }

  public static fromMonthEvents(events: MonthEvent[]): EventEditor[] {
    return events.map((m) => new EventEditor(m)).sort(EventEditor.eventComparer);
  }

  public firstInstanceInWeek(weekStart: Date, dayInWeek: Date): boolean {
    return (
      isSameDay(this.startDate, dayInWeek) || (isBefore(this.startDate, weekStart) && isSameDay(dayInWeek, weekStart))
    );
  }

  public showsOnThisDay(d: Date): boolean {
    return isBefore(this.startDateTime, addDays(d, 1)) && isAfter(this.endDateTime, d);
  }

  get effectivelyAllDay(): boolean {
    return !isEqual(this.startDate, addDays(this.endDate, -1));
  }

  public showsOnDaysWithinWeek(weekStart: Date, weekEnd: Date): number {
    return differenceInDays(min([this.endDate, weekEnd]), max([this.startDate, weekStart]));
  }
}
